
import Vue from 'vue';
import config from '~/core/config/portal.config';

interface Data {
  loaded: boolean;
  show: boolean;
  bookmarks: string[];
  popup: {
    width: number;
    height: number;
    name: string;
  };
  size: string | null;
  isDesktop: boolean;
  config: typeof config;
}

interface Computed {
  facebookUrl: string;
  twitterUrl: string;
  link: string;
}

interface Methods {
  popupWindow: (url: string, provider: string) => void;
  copyLink: (link: string) => void;
  clickEvent: (type: string) => void;
  mobileShare: () => void;
  shareAction: () => void;
  getWidth: () => void;
}

export default Vue.extend<Data, Methods, Computed, unknown>({
  data() {
    return {
      config,
      loaded: false,
      size: null,
      show: false,
      isDesktop: false,
      share: {
        title: '',
        text: '',
        url: '',
      },
      popup: {
        width: 500,
        height: 400,
        name: 'share_dialog',
      },
      bookmarks: [],
    };
  },
  computed: {
    facebookUrl() {
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURI(this.link)}&t=${encodeURI((document && document.title) || '')}`;
    },
    twitterUrl() {
      return `https://twitter.com/share?url=${encodeURI(this.link)}&text=${encodeURI((document && document.title) || '')}`;
    },
    link() {
      return `${this.config.meta.metaUrl}${this.$route.path}`;
    },
  },
  mounted() {
    this.loaded = true;
    this.getWidth();
    document?.addEventListener('resize', this.getWidth);
  },
  methods: {
    popupWindow(url, provider) {
      this.clickEvent(provider);
      const params = `width=${500},height=${500}`;
      window?.open(url, 'test', params);
      this.show = false;
    },
    getWidth() {
      this.isDesktop = window?.screen?.width >= 992;
    },
    shareAction() {
      if (this.isDesktop) this.show = true;
      else this.mobileShare();
    },
    async mobileShare() {
      try {
        const data = {
          title: document.title,
          text: '',
          url: this.link,
        };
        await navigator.share(data);
      } catch (error: any) {
        if (error.toString().includes('AbortError')) return;
        else this.show = true;
      }
    },
    async copyLink(link) {
      try {
        this.clickEvent('link');
        await navigator.clipboard
          .writeText(link)
          .catch(() => null)
          .finally(() => {
            this.$notify({ title: 'Kopeeritud', type: 'success' });
          });
        this.show = false;
      } catch (error) {
        this.$notify({ title: String(this.$t('words.error')), type: 'error' });
      }
    },
    clickEvent(type: string) {
      const recipe = this.$store.getters['activeRecipe'];

      const eventData: Record<string, unknown> = {
        share_channel: type,
        recipe_name: recipe.title.toLowerCase(),
        recipe_id: recipe.id,
        recipe_author: recipe.author.toLowerCase(),
      };

      this.$store.commit('analytics/setClickEvent', {
        cXense: {
          eventName: 'recipe_share',
          eventData,
        },
      });
    },
  },
  beforeDestroy() {
    document?.removeEventListener('resize', this.getWidth);
  },
});
